<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Rider Meter Reading Log</strong>
               
          </div>       
          <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
            <b-row>           
              <b-col sm="4">
               <b-col sm="12" >

              <!-- {{valueAgent}} -->
                         
      <div id='container' style="width:250px;">
        
           <ejs-multiselect id='multi_select' placeholder="Select Rider" v-model="valueAgent"  :dataSource='optionsAgent'  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='fieldAgent' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" ></ejs-multiselect>
          </div>

                    <!-- <b-form-group label="DeliveryAgent" :label-cols="4" >
                 <b-form-select class="form-control input" v-model="deliveryagentid" name="deliveryagentid" >
                        <option :value="selected" >--Select--</option>
                        <option v-for="agent in agentmaster" v-bind:value="agent.deliveryagentmasterid">{{ agent.deliveryagentfirstname}} {{ agent.deliveryagentlastname}}-{{ agent.deliveryagentmasterid}}</option>
                  </b-form-select>
               </b-form-group> -->
                  </b-col>
              </b-col>
               <b-col sm="4">
                <b-form-group label="From Date:"  :label-cols="4" >
                 <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateFrom'>
                </v-date-picker>
                </b-form-group>
              </b-col>

               <b-col sm="4">
                <b-form-group label="To Date:"  :label-cols="4" >
                  <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateTo'>
                  </v-date-picker>
                </b-form-group>
              </b-col>

            </b-row>
             <b-row>
            <b-col sm="4">
              <b-col sm="12" >
                <b-form-group>
                 <b-button type="submit" size="md" variant="primary" @click="showimgthumbnails(1)"> Search</b-button>
                
                  <b-button type="submit" size="md" variant="primary" @click="clear()"style="margin-left: 10%"> clear</b-button>
                
                   
                 
                </b-form-group>
              </b-col>
              </b-col>

            <b-col sm="8" >
              <b-form-group>
                <b-button v-if="total_thum_Rows>0" type="submit" variant="primary" size="md" @click="downloadCSV()" style="float: right">Download </b-button>
              </b-form-group>
            </b-col>
             </b-row>
           
            <b-row>
            

              
             <div id="overlay" >
             <div class="loader"></div>
           </div>
            <b-col sm="12" class="text-right  " >
                <b>Total Records :<span style="color:red;">{{total_thum_Rows }}</span></b>   &nbsp;&nbsp;&nbsp;
               
              </b-col>
           <!-- :to="{ name: 'designsummry', params: { id: route_id } }" -->
           <!-- <b-col sm="12" class="text-right" >
                <router-link class="px-4 pull-right" to="" >
                    <b-button type="submit" variant="primary" class="px-4 pull-right" >View Thumbnails</b-button>
                </router-link>

            
              </b-col> -->
            
            </b-row> 
          </b-form>         
            
            <!-- Code for Thumbnail View of Image -->
             <div class="overflow-auto" >
              
              <div class="col-md-12"  style="background-color: #c8ced3">
              <br>
              <div v-if="total_thum_Rows>0" class="card" :current-page="currentPage" :perPage="perPage" style="background-color: #c8ced3; ">
             <div class="card-body" style="background-color: #c8ced3;">
                <div   class="col-md-3" v-for="thumbnails in thumbnailview.slice((currentPage-1)*perPage,(currentPage-1)*perPage+perPage)" style="float: left; margin-bottom: 50px;">
                 
                   <div class="card-deck " >

                      <div class="card deck" >
                         <!----><!---->
                         <div class="card-body thumbnailbody">
                           
                            <p class="card-text">
                            
                            <div class="cardall">
                              <b-card-header header-tag="header" class="p-2 summaryheader">
                               <!-- <strong>Rider ID</strong> -->
                                <strong v-b-tooltip.hover title="Rider Name - Id"> {{thumbnails.deliveryagentname}} - {{thumbnails.deliveryagentmasterid}}</strong>

                              </b-card-header>
                             
                                
                                <div  style="text-align: center;" >
                                <!--   <img  v-bind:src=" thumbnails.shipment_images[0].imagepath" class="img_class" style=""></div> -->
                                <img  v-bind:src=" thumbnails.vehiclestartmeterreadingimage"  @click="thumbnailimagemodel(thumbnails.vehiclestartmeterreadingimage)" class="img_class" style=""></div>
                              
                         
                            </div>
                            </p>

                      </div>
                      <br><br><br><br>
                      <!-- {{designs.designer_name.substring(0,13)+".."}} 
                      thumbnails.shipment_images[0].imagepath-->
                      <div  class="card-footer summaryfooter">
                         <!-- <label v-b-tooltip.hover title="Vehicle Number" >
                          <strong>Vehicle No : </strong>
                          {{thumbnails.vehicleno}} 
                          </label>
                         <label v-b-tooltip.hover title="Vehicle Meter Reading" >
                          <strong>Meter Reading : </strong>
                           {{thumbnails.vehiclestartmeterreading}} KM
                      </label>
                      
                          <label v-b-tooltip.hover title="Created Date" >
                          <strong>Date : </strong>
                          {{thumbnails.createddate}} 
                          </label> -->
                         
                      <!-- </div> -->
                      <!-- </span> -->
                      <!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
                  <b-row>
                      
                        <b-col sm="12">
                       <label v-if="thumbnails.vehicleno != null" v-b-tooltip.hover :title="thumbnails.vehicleno" >
                          <strong>Vehicle No : </strong>
                          {{thumbnails.vehicleno.substring(0,10)+" ..."}}&nbsp;
                          </label>
                        </b-col>
                      <b-col sm="12">
                        <label v-if="thumbnails.vehiclestartmeterreading != null" v-b-tooltip.hover :title="thumbnails.vehiclestartmeterreading" >
                       <strong>Meter Reading : </strong>
                          {{thumbnails.vehiclestartmeterreading.substring(0,8)+" .."+"KM"}}&nbsp;
                        </label>
                      </b-col>
                      <b-col sm="12">
                         <label v-if="thumbnails.createddate != null" v-b-tooltip.hover :title="thumbnails.createddate" >
                          <strong>Date : </strong>
                          {{thumbnails.createddate.substring(0,16)+" ..."}} 
                          </label>
                      </b-col>
  
  
 <br><br>
                     </b-row>              
                          
                     
                         </div>

                        
                      
                      </div>
                      
                   </div>
                   <br>
                

                </div>
                   
               
         
             </div>
          </div>
          <div v-else style="text-align:center">
            <span >No Record Found</span>
          </div>
<!--  <b-col md="12" class="my-1" v-if="total_thum_Rows>'0'">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="total_thum_Rows"
                  :per-page="perPage"
                  class="my-0"
                ></b-pagination>
              </b-col> -->
            </div>
          <b-col md="12" class="my-1" v-if="total_thum_Rows>'20'">
             <b-pagination v-model="currentPage" :total-rows="total_thum_Rows" :per-page="perPage" first-text="First" prev-text="Prev" next-text="Next" last-text="Last"></b-pagination>
           </b-col>
          </div>

          <b-modal  size="lg" title="Image Zoom" v-model="openimagemodel" @ok="openimagemodel = false" hide-footer>
         
          <template slot="default" slot-scope="{ hide }">
            <div id="btn_zoom" >
              
              <button type="button" class="btn btn-primary" @click="zoomin()"><i class="fa fa-search-plus" aria-hidden="true">&nbsp;Zoom In</i></button>&nbsp;
              <button type="button" class="btn btn-danger" @click="zoomout()"><i class="fa fa-search-minus" aria-hidden="true">&nbsp;Zoom Out</i></button>
              </div>

              <div class="main1" style="text-align: center;">
              <img v-bind:src="captureKMimg" id="map" height="300" width="300" style="padding-top:10px;"/>
              </div>


            
              <br>
                <div slot="footer" class="text-right">
                 <!--  <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update</b-button> -->
                  <b-button  size="sm" variant="danger" @click="openimagecancel()">cancel</b-button>
                </div>

          </template>
          <template slot="modal-footer" slot-scope="{ hide }">
            
            <b-button size="sm" style="display:none">
              Cancel
            </b-button>
            
          </template>
      </b-modal> 
          

        </b-card>
      </b-col>
    </b-row>    
  </div>
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from 'vue'
export default {
  data: function() {
    return {
      // thumbimagemodel:false,
    
      thumbnailotherimg:[],
     
      thumbnailview:[],
      data: [], 
     currentPage:1,
     pageNum:1,
      hubid:'',
      data1:[],
      perPage:  20,
     
   
      awbno:'',
      deliveryagentid:'',
      agentmaster: [],
      
      selectDateFrom: new Date(),
      selectDateTo:new Date(),
     
  
       
        total_thum_Rows:0,
        captureKMimg:'',
        openimagemodel:false,
      optionsAgent:[],
      valueAgent:[],
      fieldAgent:{ text: 'name', value: 'id' },
      showSelectAll : true,
      allowCustomValue : true,
     
        // searching:'',
    
      
    };
  },
  // computed: {
    // sortOptions() {
    //     // Create an options list from our fields
    //     return this.fields
    //       .filter(f => f.sortable)
    //       .map(f => {
    //         return { text: f.label, value: f.key }
    //       })
    //   }
  // },
     computed: {
        rows() {
          return this.items.length
        },
        
      },
  created: function() {
   
    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
    this.email=userInfo.sysemailid;
     
    this.hubid=userInfo.pickuplocationmasterid.toString();
   
   
    this.displaydeliveryagent();
    // this.showimgthumbnails(this.pageNum);
  },
  methods: {
    
  
    validateForm(scope) {},
 
   

   
   


     
       // Function for  image model 
       thumbnailimagemodel:function(image){
        console.log("image",image);
        this.captureKMimg=image;
        console.log("captureKMimg",this.captureKMimg);
        this.openimagemodel=true;
        
        
       },
       openimagecancel:function(){
        this.openimagemodel=false;
       },
       zoomin: function(){
        var myImg = document.getElementById("map");
        var currWidth = myImg.clientWidth;
        if(currWidth >= 650) return false;
         else{
            myImg.style.width = (currWidth + 100) + "px";
        } 
    },
    zoomout: function(){
        var myImg = document.getElementById("map");
        var currWidth = myImg.clientWidth;
        if(currWidth <= 270) return false;
     else{
            myImg.style.width = (currWidth - 100) + "px";
        }
    },

  clickCallback (pageNum)
       {
      //   alert(" i m in pagination task");
      // alert(pageNum)
      this.showimgthumbnails(pageNum);
    },
     showimgthumbnails: function(pagee) {
      document.getElementById("overlay").style.display = "block";
       var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)

     
       var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
        var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
         // var deliveryagentid=(this.deliveryagentid!=null)? this.deliveryagentid:"";

          var thumbnailsObj = {
            fromdate: `${fromdate}`,
            todate:`${formatdateto}`,
            deliveryagentid:this.valueAgent,
            
           };
         
       

        // if(formatdateto< fromdate){
        //    alert('To date need to be grater than From date');  
                  
        // }

        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getAllRiderVehicleReadingDetails`, thumbnailsObj)
          .then(result => {
            console.log("result",result);
             // this.isBusy = !this.isBusy;

           document.getElementById("overlay").style.display = "none";
            if (result.body.returnmsg  == 'Successful') {
              this.thumbnailview=result.body.returnvalue;
               console.log("thumbnailview", this.thumbnailview);
               
                this.total_thum_Rows = result.body.returnvalue.length;  
                
            }else{
             
              this.total_thum_Rows = 0;    
              this.thumbnailview=result.body.returnvalue;           
             
            }
          })
          .catch(ex => {
            console.log("error-----", ex);
          });
    },

downloadCSV:function(){
  document.getElementById("overlay").style.display = "block";
       var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)

     
         var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
        var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
         // var deliveryagentid=(this.deliveryagentid!=null)? this.deliveryagentid:"";

          var csvObj = {
             fromdate: `${fromdate}`,
            todate:`${formatdateto}`,
            deliveryagentid:this.valueAgent,
            hub_id:`${userInfo.pickuplocationmasterid}`,
            sysusermasterid:`${userInfo.sysusermasterid}`,
           };
         
       

        // if(formatdateto< fromdate){
        //    alert('To date need to be grater than From date');  
                  
        // }

        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getAllRiderVehicleReadingCsv`, csvObj)
          .then(result => {
            console.log("result",result);
             // this.isBusy = !this.isBusy;

           document.getElementById("overlay").style.display = "none";
             if(result.body=="success")
         {
         alert("Please Check Your Mail For Downlod Link")
         
       }
       else
       {
        alert("Can not Download");
       

       }
         
          })
          .catch(ex => {
            console.log("error-----", ex);
          });
},
    
    
   



    

    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");

    },
      clear: function() {
   this.searching="";
   this.deliveryagentid="";
   this.selectDateFrom=new Date();
   this.selectDateTo=new Date();
   this.valueAgent=[];
   // this.Pickup="";
   // this.shipmentstatus="";
   // this.shipmenttype="";
   // this.selectDateFrom="";
   // this.selectDateTo="";
    // this.filter="";
    this.showimgthumbnails(this.pageNum);
   
   
      
    },
   








    displaydeliveryagent: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      //agentmaster
      const deliveryagent = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1',
         hub_id:`${userInfo.pickuplocationmasterid}`,
      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagent)
        .then((result) => {
          
         console.log("YYY",result);
          // if (result.body.returnmsg === 'Successful') {
            // this.isBusy = !this.isBusy
            // this.data = result.body;
           
            this.agentmaster = result.body;
            this.showimgthumbnails(this.pageNum);
            // this.cityDatalength=result.body.returnvalue.length;
              for(let i = 0; i < this.agentmaster.length; i++) {
             var deliveryagent2 = {
                    name: this.agentmaster[i].deliveryagentfirstname+" - "+this.agentmaster[i].deliveryagentlastname +" - "+ this.agentmaster[i].deliveryagentmasterid,
                    id: this.agentmaster[i].deliveryagentmasterid.toString(),
                  }
 this.optionsAgent.push(deliveryagent2);
 console.log("HHHHAAAA",this.optionsAgent);
}
                   
        })
        .catch((ex) => {
          console.log('error', ex)
        })
    }

  }
};
</script>

<style lang="css">
.popover-container {
  width: 100%;
}
.popover-container input {
  -moz-appearance: none;
  -webkit-appearance: none;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 3px;
  -webkit-box-shadow: none;
  box-shadow: none;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 1rem;
  height: 2.25em;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  line-height: 1.5;
  padding-bottom: calc(0.375em - 1px);
  padding-left: calc(0.625em - 1px);
  padding-right: calc(0.625em - 1px);
  padding-top: calc(0.375em - 1px);
  position: relative;
  vertical-align: top;
  background-color: white;
  border-color: #dbdbdb;
  color: #363636;
  -webkit-box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  max-width: 100%;
  width: 100%;
}
.table tr th {
  color: #fff !important;
  padding: .2rem!important;
}
.table thead,
.table thead tr:hover {
  background: #333 !important;
}
.table button {
  background: #b0c4de !important;
  color: #000 !important;
}
.table tr:hover {
  background: #efefef;
}
tbody tr:nth-child(even) {
  background: #f2f2f2;
}
tbody tr:nth-child(odd) {
  background: #fff;
}
.registerbox {
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  width: 1244px;
  background-color: #fff;
}
hr {
  margin-bottom: 0px;
}
.error {
  color: red;
}
button.editbtn {
  border: none;
  background: transparent !important;
}
.label {
  text-align: left;
}
.select {
  width: 100%;
}
  .nameOfTheClass {
   max-width: 450px !important;
}
.orderidClass{
   max-width: 110px !important;
}
.awbClass{
  max-width: 110px !important;
}
.statusClass{
 max-width: 110px !important; 
}
.desitnationClass{
  max-width: 110px !important; 
}
.countryClass{
 max-width: 60px !important;  
}
.pickupClass{
  max-width: 100px !important; 
}
#overlay {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .loader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
/*tbody tr:nth-child(odd) {
    background: darkgray !important;
}*/
.cardall{
  width: 100%;
  float: left; 
  margin-bottom: 30px;
  height: 140px ;
}
.img_class {
    width: 100%;
    height: 200px ;
    margin-top: 12px;
    text-align: center;
  
}
.thumbnailbody{
  padding:5px;
}
.img_class_model{
   width: 100%;
    height: 240px ;

    text-align: center;
}
.summaryfooter{
  padding:10px;
}
.deck{
  display: flex;
    flex: 1 0 0%;
    flex-direction: column;
    margin-right: 0px;
    margin-bottom: 0;
    margin-left: 15px;

}
#btn_zoom{
  text-align: center;
  padding-top: 10px;
}
.summaryfooter {
    padding: 5px;

}
</style>
